import { emsApi } from '@/api/emsApi';
import type { GeoPoint } from '@/signalr';

export type AddressSearchResultItem = {
  name: string;
  label: string;
  position: GeoPoint;
  type: string;
  location: string;
};

export const MAPY_CZ_POSITION_TYPE_COORDINATE = 'coordinate';

export async function searchAddress(address: string, language: string): Promise<AddressSearchResultItem[]> {
  const { data, response } = await emsApi.POST('/portal/v1/geocoding/search', {
    body: { address, language },
  });

  if (data === undefined) {
    throw new Error(`Address search failed (HTTP ${response.status})`);
  }

  return data.map((item) => ({
    name: item.name ?? '',
    label: item.label ?? '',
    position: {
      latitude: item.position?.latitude ?? 0,
      longitude: item.position?.longitude ?? 0,
    },
    type: item.type ?? '',
    location: item.location ?? '',
  }));
}

export type PortalPsapInfo = {
  id: string;
  displayName: string;
  position: GeoPoint | null;
};

export const ADD_PSAP_TO_INCIDENT_CONFIGURATION_QUERY_KEY = [
  'configuration',
  'add-psap-to-incident',
] as const;

export async function fetchAddPsapToIncidentConfiguration(): Promise<{ relatedPsaps: PortalPsapInfo[] }> {
  const { data, response } = await emsApi.GET('/portal/v1/configuration/add-psap-to-incident');

  if (data === undefined) {
    throw new Error(`Loading the add-PSAP-to-incident configuration failed (HTTP ${response.status})`);
  }

  return {
    relatedPsaps: (data.relatedPsaps ?? []).map((psap) => ({
      id: psap.id ?? '',
      displayName: psap.displayName ?? '',
      position:
        psap.position?.latitude != null && psap.position.longitude != null
          ? { latitude: psap.position.latitude, longitude: psap.position.longitude }
          : null,
    })),
  };
}
